import { Injectable } from '@angular/core';
import { ApiService } from '../api/api.service';

@Injectable({
  providedIn: 'root'
})
export class UsuarioService {

  constructor(
    private apiService: ApiService
  ) { }

  //logear user//  
  sendLoginToken(token){
    return this.apiService.validateUser(token);
  }

  //save localstorage user and token//
  saveLocalStorage(user, token){
    localStorage.setItem( 'session_user', JSON.stringify(user) );
    localStorage.setItem( 'access_token', token );
  }
  //clear localstorage user and token//  
  clearLocalStorage(){
    localStorage.removeItem( 'session_user' );
    localStorage.removeItem( 'access_token' );
  }

  getLocalStorage(){
    let user = localStorage.getItem( 'session_user' );
    let token = localStorage.getItem( 'access_token' );

    return { user : JSON.parse(user), token : token }
  }

  updateTerms(token, data){
    return this.apiService.updateTerms(token, data);
  }

  validateLogin(){
    let token = localStorage.getItem( 'access_token' );
    let user = JSON.parse(localStorage.getItem( 'session_user' ));
    if( token && user){
      if(token.length > 5 && user['terminos'] === true){
        return true;
      }else{
        return false;
      }
    }else{
      return false;
    }
  }

  getProfileUser(token){
    return this.apiService.getProfileUser(token);
  }

  updateProfileUser(token, data){
    return this.apiService.updateProfileUser(token, data);
  }
}
